import RemoveSelection from './_remove-selection.js'
import Odds from './_odds.js'
import OddsDropdown from './_odds-dropdown.js'
import BetErrors from './_bet-errors.js'
import BetslipBet from './_betslip-bet.js'
import StakeInput from './_stake-input.js'
import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import SelectableButton from './_selectable-button.js'
import Spinner from './_spinner.js'
import DateTime from './_date-time.js'
import Dropdown from './_dropdown.js'
import KeyValueMap from './_key-value-map.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'

export default {
  name: 'DefaultBetContent',
  values: {
    removeSelection: {
      configSet: RemoveSelection,
      configValues: {},
    },
    odds: {
      configSet: Odds,
      configValues: {},
    },
    oddsDropdown: {
      configSet: OddsDropdown,
      configValues: {},
    },
    betErrors: {
      configSet: BetErrors,
      configValues: {},
    },
    betslipBet: {
      configSet: BetslipBet,
      configValues: {},
    },
    stakeInput: {
      configSet: StakeInput,
      configValues: {},
    },
    selectionInfoButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            position: 'unset',
            flexDirection: 'column',
            padding: '0 0 0 24px',
          },
        },
      },
    },
    selectionInfoWrapper: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    selectionNameSuspended: {
      configSet: Text,
      configValues: {},
    },
    selectionName: {
      configSet: Text,
      configValues: {},
    },
    marketNameSuspended: {
      configSet: Text,
      configValues: {},
    },
    marketName: {
      configSet: Text,
      configValues: {},
    },
    eventName: {
      configSet: Text,
      configValues: {},
    },
    eventNameSuspended: {
      configSet: Text,
      configValues: {},
    },
    showBankerSpinnerDelay: 500,
    bankerButton: {
      configSet: SelectableButton,
      configValues: {
        unselected: {
          style: {
            base: {
              alignItems: 'center',
              maxHeight: '40px',
              minHeight: '40px',
              minWidth: '40px',
            },
          },
        },
        selected: {
          style: {
            base: {
              alignItems: 'center',
              maxHeight: '40px',
              minHeight: '40px',
              minWidth: '40px',
            },
          },
        },
      },
    },
    bankerSpinner: {
      configSet: Spinner,
      configValues: {},
    },
    bankerSpinnerSelected: {
      configSet: Spinner,
      configValues: {},
    },
    multicastSelectionInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexBasis: '100%',
        },
      },
    },
    multicastSelectionName: {
      configSet: Text,
      configValues: {},
    },
    multicastMarketName: {
      configSet: Text,
      configValues: {},
    },
    multicastEventName: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    multicastAllOddsButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            padding: '0 0 4px 0',
            justifyContent: 'left',
          },
        },
      },
    },
    eventNameTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    marketSwitchDropdown: {
      configSet: Dropdown,
      configValues: {
        controlText: undefined,
        controlTextSelected: undefined,
        style: {
          rootContainer: {
            height: '40px',
          },
        },
        menuItem: {
          style: {
            base: {
              minHeight: '40px',
            },
          },
        },
      },
    },
    marketSwitchItemsOverride: {
      configSet: KeyValueMap,
      configValues: {},
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
